<!-- TOP IMAGE  -->
<div class="bc-banner" *ngIf="assortment?.extra?.images?.length > 0">
  <div class="top-image overlay" *ngIf="assortment?.extra?.images?.length > 0" [ngStyle]="style"></div>
  <div class="description" *ngIf="assortment">
    <h2 *ngIf="showAssortmentBannerText && assortment.name">
      {{ assortment.extra?.i18n?.[currentLang]?.assortmentName || assortment.name }}
    </h2>
    <!-- Add description here -->
  </div>
</div>